export default "__VITE_ASSET__8JQbOLAf__"